import EyekandyEventLogging from "../abstracts/EyekandyEventLogging";

class EyekandyProjectsLogging extends EyekandyEventLogging {
  constructor(options){
    super(options)
    //
    //  Set the values from our current class.
    this.destination = "projects"
  }

  preLogCallback(payload){    
    //
    //  Ok, now return the payload exactly as it will be sent.
    return payload
  }

  log(type, detail, project, arid){
    //
    //  Always sent ARID as a string.
    if(arid){
      arid = `${arid}`
    }
    //
    //  Define our logging payload.
    const payload = {
      type: type || null,
      detail: detail || null,
      project: project || null,
      arid: arid || null
    }
    //
    //  Send the log out.
    return this._log(payload)
  }

}

//
//  :exports:
export default EyekandyProjectsLogging
